<form *ngIf="isPlatformBrowser(platformId); else loading" [formGroup]="form">
  <formly-form [fields]="fields" [form]="form" [model]="model" [options]="options"></formly-form>
</form>

<ng-template #equipmentItemLabelTemplate let-object="item">
  <ng-container *ngIf="model && model.value">
    <ng-container *ngIf="!!object?.item; else noItemObject">
      <astrobin-equipment-item-display-name
        [enableSummaryPopover]="enableSummaryPopover"
        [item]="object.item"
      ></astrobin-equipment-item-display-name>
    </ng-container>
    <ng-template #noItemObject>
      <astrobin-equipment-item-display-name
        *ngIf="!!object?.value; else loading"
        [enableSummaryPopover]="enableSummaryPopover"
        [itemId]="object.value"
        [itemType]="type"
      ></astrobin-equipment-item-display-name>
    </ng-template>
  </ng-container>
</ng-template>

<ng-template #equipmentItemOptionTemplate let-object="item">
  <div (click)="onOptionClicked($event, object)" class="option-wrapper">
    <astrobin-equipment-item-display-name
      [item]="object.item"
      [showFrozenAsAmbiguous]="object.item.variants?.length === 0"
    ></astrobin-equipment-item-display-name>

    <ng-container *ngIf="!!object.item.variants && object.item.variants.length > 0">
      <p class="item-variants-info">{{ variantsMessage(object.item.variants.length) }}</p>
      <p class="item-variants-list">
        <span *ngFor="let variant of object.item.variants">
          <astrobin-equipment-item-display-name
            [cut]="object.item.name"
            [item]="variant"
            [showBrand]="false"
          ></astrobin-equipment-item-display-name>
        </span>
      </p>
    </ng-container>
  </div>
</ng-template>

<ng-template #footerTemplateExtra>
  <div class="text-muted">
    {{
      "AstroBin's equipment database is entirely maintained by the community. Feel free to make a contribution!"
        | translate
    }}
    <a href="https://welcome.astrobin.com/features/equipment-database" target="_blank">{{ "Learn more" }}.</a>
  </div>
</ng-template>

<ng-container *ngIf="options.formState.creationMode">
  <div class="mt-4 mb-4 text-center">
    <fa-icon icon="arrow-down"></fa-icon>
  </div>

  <div class="mt-4 mb-4">
    <div [class.disabled-with-backdrop]="options.formState.subCreationMode" id="create-new-item" class="card">
      <div class="backdrop"></div>

      <div class="card-header">
        {{ "Create a new item" | translate }}
      </div>

      <div class="card-body">
        <astrobin-read-only-mode *ngIf="(readOnlyMode$ | async) === true; else formTemplate"></astrobin-read-only-mode>

        <ng-template #formTemplate>
          <astrobin-camera-editor
            #editor
            *ngIf="type === EquipmentItemType.CAMERA"
            [form]="creationForm"
            [model]="creationModel"
            [name]="q"
            (subCreationInProgress)="onSubCreationInProgress($event)"
            (suggestionSelected)="itemCreated($event)"
          ></astrobin-camera-editor>

          <astrobin-sensor-editor
            #editor
            *ngIf="type === EquipmentItemType.SENSOR"
            [form]="creationForm"
            [model]="creationModel"
            [name]="q"
            (subCreationInProgress)="onSubCreationInProgress($event)"
            (suggestionSelected)="itemCreated($event)"
          ></astrobin-sensor-editor>

          <astrobin-telescope-editor
            #editor
            *ngIf="type === EquipmentItemType.TELESCOPE"
            [form]="creationForm"
            [model]="creationModel"
            [name]="q"
            (subCreationInProgress)="onSubCreationInProgress($event)"
            (suggestionSelected)="itemCreated($event)"
          ></astrobin-telescope-editor>

          <astrobin-mount-editor
            #editor
            *ngIf="type === EquipmentItemType.MOUNT"
            [form]="creationForm"
            [model]="creationModel"
            [name]="q"
            (subCreationInProgress)="onSubCreationInProgress($event)"
            (suggestionSelected)="itemCreated($event)"
          ></astrobin-mount-editor>

          <astrobin-filter-editor
            #editor
            *ngIf="type === EquipmentItemType.FILTER"
            [form]="creationForm"
            [model]="creationModel"
            [name]="q"
            (subCreationInProgress)="onSubCreationInProgress($event)"
            (suggestionSelected)="itemCreated($event)"
          ></astrobin-filter-editor>

          <astrobin-accessory-editor
            #editor
            *ngIf="type === EquipmentItemType.ACCESSORY"
            [form]="creationForm"
            [model]="creationModel"
            [name]="q"
            (subCreationInProgress)="onSubCreationInProgress($event)"
            (suggestionSelected)="itemCreated($event)"
          ></astrobin-accessory-editor>

          <astrobin-software-editor
            #editor
            *ngIf="type === EquipmentItemType.SOFTWARE"
            [form]="creationForm"
            [model]="creationModel"
            [name]="q"
            (subCreationInProgress)="onSubCreationInProgress($event)"
            (suggestionSelected)="itemCreated($event)"
          ></astrobin-software-editor>
        </ng-template>
      </div>

      <div class="card-footer">
        <button
          [class.loading]="loadingService.loading$ | async"
          (click)="onCancel()"
          class="btn btn-sm-block btn-secondary"
        >
          {{ "Cancel" | translate }}
        </button>

        <button
          [class.loading]="(loadingService.loading$ | async) || creationForm.pending"
          [disabled]="(readOnlyMode$ | async) === true"
          (click)="createItem()"
          class="btn btn-sm-block btn-primary"
        >
          {{ "Create item" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #fullScreenBodyTemplate>
  <astrobin-hr [text]="'or' | translate" class="mb-3"></astrobin-hr>

  <div class="full-screen-body-template-content">
    <astrobin-item-browser-by-properties
      [type]="type"
      (createClicked)="onCreateClickedBrowsingByProperties()"
      (itemSelected)="onItemSetByBrowsingByProperties($event)"
    ></astrobin-item-browser-by-properties>
  </div>
</ng-template>

<ng-template #loading>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
